"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMicroscope = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5.5a4.5 4.5 0 0 1 8.979-.443 9 9 0 0 1 4.397 17.288 1 1 0 0 1-.751-1.854A7.003 7.003 0 0 0 12 7.071v5.693c.475.425.813.999.942 1.65a6.03 6.03 0 0 1 0 2.171 3 3 0 0 1-2.357 2.357c-.293.059-.62.058-1.001.058H5.416c-.38 0-.708 0-1.001-.058a3 3 0 0 1-2.357-2.357 6.03 6.03 0 0 1 0-2.17c.13-.652.467-1.226.942-1.65V5.5Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M3 21a1 1 0 1 0 0 2h9a1 1 0 0 0 0-2H3Z", fill: "currentColor" })] }))); };
exports.default = SvgMicroscope;
